<script lang="ts">
  import { browser } from '$app/environment'
  import { writable, type Writable } from 'svelte/store'
  import Button from './base/Button.svelte'
  import type { Theme } from '../types/theme'
  import { utils } from '../utils'

  export let defaultTheme: Theme = 'light'

  if (browser) {
    const prefersDark =
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches

    const storedTheme = utils.theme.get()

    if (storedTheme === 'dark' || (!storedTheme && prefersDark)) {
      defaultTheme = 'dark'
    }
  }

  export let theme: Writable<Theme | null> = writable(defaultTheme)

  function handleToggle() {
    const newTheme = $theme === 'dark' ? 'light' : 'dark'
    theme.set(newTheme)
    utils.theme.set(newTheme)
    document.documentElement.toggleAttribute('dark-theme')
  }
</script>

<Button
  rounded
  type="button"
  variant="text"
  icon={$theme === 'dark' ? 'ph-moon-stars' : 'ph-sun'}
  on:click={handleToggle}
/>
